import { useScroll, useMotionValueEvent } from "framer-motion";
import { useState } from 'react';
import ChatBubble from './ChatBubble';
import FloatingOfferButton from './FloatingOfferButton';

const FloatingActionButtons = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, "change", (latest) => {
    // Show button when scrolled more than 100px
    setIsScrolled(latest > 100);
  });

  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-end gap-4" style={{ flexDirection: 'row-reverse' }}>
      <div className="relative">
        <ChatBubble />
      </div>
      <div className="relative">
        <FloatingOfferButton isScrolled={isScrolled} />
      </div>
    </div>
  );
};

export default FloatingActionButtons;
